<template>
  <div class="form">
    <ui-input
        :type="'email'"
        :label="t('fields.email')"
        :rules="[required]"
        v-model="email"
    />
    <div class="form__captcha">
      <Checkbox v-model="captcha" />
    </div>
    <ui-button
        class="form__button"
        :isDisabled="!isFormValid"
        @click="reset"
    >
      {{ t('buttons.reset') }}
    </ui-button>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiInput from "@/components/ui/ui-input.vue";
import {isEmail, required} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import UiButton from "@/components/ui/ui-button.vue";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";
import {useRouter} from "vue-router";
import { Checkbox } from 'vue-recaptcha';

const {t} = useI18n()

const email = ref('')
const captcha = ref()

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    captcha.value
  )
})

const reset = async () => {
  isLoading.value = true

  const res = await Auth.resetPassword(email.value);

  if (res.errors) {
    ElNotification({
      title: t('popup.error'),
      message: res.errors[0].message,
      type: 'error'
    })
  } else {
    ElNotification({
      message: t('popup.reset'),
      type: 'success'
    })
  }

  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.form {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-block: 20px 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  &__title {
    color: #2F2F2F;
    font-size: 22px;
    font-weight: 600;
    line-height: 30.8px;
    text-transform: uppercase;
  }

  &__link {
    transition: 0.2s;

    @include hover {
      color: #6c6c6c;
    }
  }

  &__button {
    padding-block: 12px;
    font-size: 14px;
  }

  &__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__lost {
    position: relative;
    color: #FF6162;
    font-size: 14px;
    font-weight: 400;
    line-height: 22.4px;

    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      height: 2px;
      width: 0;
      transition: all .3s ease;
      background-color: #FF6162;
    }

    @include hover {
      &::after {
        width: 100%;
      }
    }
  }
}

@media (max-width: 1100px) {
  .form {
    width: 400px;
  }
}

@media (max-width: 500px) {
  .form {
    width: 100%;
  }
}
</style>